import React from "react";
import PropTypes from "prop-types";
import "./CustomSwitch.css";

// All styles are handled in CustomSwitch.css

const ToggleSwitch = ({
  id,
  name,
  tabIndex,
  checked,
  onChange,
  optionLabels = ["Yes", "No"],
  small,
  className,
  disabled,
}) => {
  const onLabel = optionLabels[0];
  const offLabel = optionLabels[1];

  const handleKeyPress = (e) => {
    if (e.key !== " " && e.key !== "Spacebar") return;
    e.preventDefault();
    onChange(!checked);
  };

  return (
    <div
      className={`toggle-switch${small ? " small-switch" : ""}${
        className ? " " + className : ""
      }`}
    >
      <input
        type="checkbox"
        name={name}
        className="toggle-switch-checkbox"
        id={id}
        tabIndex={tabIndex}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        onKeyDown={handleKeyPress}
      />
      {id && (
        <label
          id={`${id}_label`}
          className="toggle-switch-label"
          onKeyDown={handleKeyPress}
          htmlFor={id}
        >
          <span
            className={
              disabled
                ? "toggle-switch-inner toggle-switch-disabled"
                : "toggle-switch-inner"
            }
            data-yes={optionLabels[0]}
            data-no={optionLabels[1]}
            data-on={onLabel}
            data-off={offLabel}
            tabIndex={-1}
          />
          <span
            className={
              disabled
                ? "toggle-switch-switch toggle-switch-disabled"
                : "toggle-switch-switch"
            }
            tabIndex={-1}
          />
        </label>
      )}
    </div>
  );
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  optionLabels: PropTypes.array,
  small: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default ToggleSwitch;
